import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3PageDiv from "../../../core/et3-page-div";
import ChangeEmailSubscriptionForm from "./change-email-subscription-form";

const ChangeEmailSubscription = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "QA_CHANGE_EMAIL_SUBSCRIPTION",
      "QA_CHANGE_EMAIL_SUBSCRIPTION"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("QA")}
        subTitle={i18n.get("USER_EMAIL_SUBSCRIPTION")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <ChangeEmailSubscriptionForm />
    </ET3PageDiv>
  );
});

export default ChangeEmailSubscription;
